import { Parser } from 'json2csv';
import downloadFile from './download';
import moment from 'moment';

export function getCsv(data, dateFormat = 'D MMM YYYY hh:mm A') {
  const fields = [
    { label: 'Name', value: 'name' },
    { label: 'E-Mail', value: 'email' },
    { label: 'Role', value: 'role' },
    { label: 'Pending invitation', value: 'pending' },
    { label: 'Joined on', value: 'joinedOn' },
    { label: 'Last active on', value: 'lastActiveOn' },
    { label: 'Access rights', value: 'access' },
    { label: 'Create dashboards', value: 'createDashboards' },
    { label: 'Manage dashboards', value: 'manageDashboards' },
    { label: 'Manage billing', value: 'manageBilling' },
    { label: 'Manage users', value: 'manageUsers' },
  ];

  const mergedData = _(data).map(d => {
    const access = d.manageDashboards
      ? 'Full access'
      : d.manageDashboardsViewOnly
      ? 'View access only'
      : `Dashboards: ${d.dashboards.length}`;
    return {
      ...d,
      manageDashboards: !!d.manageDashboards,
      manageBilling: !!d.manageBilling,
      manageUsers: !!d.manageUsers,
      createDashboards: !!d.createDashboards,
      access,
      joinedOn: moment(d.joinedOn).format(dateFormat),
      lastActiveOn: moment(d.lastActiveOn).format(dateFormat),
    };
  }).value();

  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(mergedData);

  return csv;
}

export function saveCsv(data) {
  const csv = getCsv(data);
  const filename = `users_${moment().format('YYYY-M-D')}.csv`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  downloadFile(url, filename);
}
